import './DevPanel_DxlTreeView.scss';

import React from 'react';
import { JSONTree } from 'react-json-tree';

import PropTypes from 'prop-types';

const DevPanel_DxlTreeView = ( props ) => {

  const { ApolloState } = props;

  return (
    <div className='DevPanel_DxlTreeView'>
      <JSONTree data={ ApolloState } theme='monokai' invertTheme={ false } />
    </div>
  );
};

const propTypes = {
  ApolloState: PropTypes.object
};

const defaultProps = {
  ApolloState: {}
};

DevPanel_DxlTreeView.propTypes = propTypes;
DevPanel_DxlTreeView.defaultProps = defaultProps;

export default DevPanel_DxlTreeView;